export const PARAMETER_KEYS = {
  DISPLAY_INQUIRY_INTIMATION: 'CONFIG_DISPLAY_INQUIRY_INTIMATION',
  DISPLAY_INQUIRY_SOCIAL_DATA: 'CONFIG_DISPLAY_INQUIRY_SOCIAL_DATA',
  DISPLAY_INQUIRY_CRIMINAL_ANTECEDENTS: 'CONFIG_DISPLAY_INQUIRY_CRIMINAL_ANTECEDENTS',
  CUSTOMER: 'CONFIG_CUSTOMER',
  ENABLE_CHANGE_PENALTIES_VIEW: 'CONFIG_ENABLE_CHANGE_PENALTIES_VIEW',
  ENABLE_PROJECT_PENALTIES_LIST: 'CONFIG_ENABLE_PROJECT_PENALTIES_LIST',
  ENABLE_SEI_PROJECT_SERVICE: 'CONFIG_ENABLE_SEI_PROJECT_SERVICE',
  ENABLE_SEMA_SERVER_ACTIVITIES_VIEW: 'CONFIG_ENABLE_SEMA_SERVER_ACTIVITIES_VIEW',
  ENABLE_SEMA_AND_CEMA_ASSOCIATION_REGISTRATION:
    'CONFIG_ENABLE_SEMA_AND_CEMA_ASSOCIATION_REGISTRATION',
  ENABLE_AUDIT_LOG_VIEW: 'CONFIG_ENABLE_AUDIT_LOG_VIEW',
  ENABLE_PARTNER_ASSOCIATION_REGISTRATION: 'CONFIG_ENABLE_PARTNER_ASSOCIATION_REGISTRATION',
  DISPLAY_INQUIRY_MOVEMENT_TASKS: 'CONFIG_DISPLAY_INQUIRY_MOVEMENT_TASKS',
  CONFIG_ENABLE_INSTALLMENT_TYPES: 'CONFIG_ENABLE_INSTALLMENT_TYPES',
  DISPLAY_CIRCLE_ICONS: 'CONFIG_DISPLAY_CIRCLE_ICONS',
  MPDFT_ENABLE_STEPS_LIST: 'MPDFT_ENABLE_STEPS_LIST',
  DISPLAY_EXPIRED_AGREEMENT_HINT: 'CONFIG_DISPLAY_EXPIRED_AGREEMENT_HINT',
  DISPLAY_WAITING_HOMOLOGATION_ICON: 'CONFIG_DISPLAY_WAITING_HOMOLOGATION_ICON',
  DISPLAY_WAITING_DEVOLUTION_ICON: 'CONFIG_DISPLAY_WAITING_DEVOLUTION_ICON',
  DISPLAY_ONLY_AGREEMENT_AND_FORWARDING_STEPS: 'DISPLAY_ONLY_AGREEMENT_AND_FORWARDING_STEPS',
  CONFIG_DISPLAY_ATTENDANCE_OF_JUDGEMENT: 'CONFIG_DISPLAY_ATTENDANCE_OF_JUDGEMENT',
  ENABLE_INTIMATION_VIEW: 'CONFIG_ENABLE_INTIMATION_VIEW',
  ENABLE_PROSECUTOR_LIFETIME: 'CONFIG_ENABLE_PROSECUTOR_LIFETIME',
  HIDE_LAWYER_DATA: 'CONFIG_HIDE_LAWYER_DATA',
  ENABLE_VICTIM_INTIMATION: 'CONFIG_ENABLE_VICTIM_INTIMATION',
  DISPLAY_SOCIOEDUCATIONAL_LECTURE_PENALTIES: 'CONFIG_DISPLAY_SOCIOEDUCATIONAL_LECTURE_PENALTIES',
  DISPLAY_SUBJECTS_INQUIRY: 'CONFIG_DISPLAY_SUBJECTS_INQUIRY',
  ENABLE_PENALTY_TYPES: 'CONFIG_ENABLE_PENALTY_TYPES',
  DISPLAY_GENERAL_PENALTIES: 'CONFIG_DISPLAY_GENERAL_PENALTIES',
  ENABLE_ALL_ORIGIN_NUMBERS_ARE_NPU: 'CONFIG_ALL_ORIGIN_NUMBERS_ARE_NPU',
  ENABLE_CANCEL_AGREEMENT: 'CONFIG_ENABLE_CANCEL_AGREEMENT',
  ENABLE_INQUIRY_IMPORT: 'CONFIG_ENABLE_INQUIRY_IMPORT',
  ENABLE_MANUAL_HML: 'CONFIG_ENABLE_MANUAL_HML',
  ENABLE_REGISTER_AGREEMENT_FROM_INTIMATION: 'CONFIG_ENABLE_REGISTER_AGREEMENT_FROM_INTIMATION',
};
